import { FC, PropsWithChildren, useContext } from 'react';
import cn from 'classnames';
import { useChatStoreExtract } from '../../Chat/hooks/ChatStore.hooks';
import { GlobalStepWidth } from '../../Chat/hooks/types';
import { ChatTaskContext } from 'react-scale/components/scalers/tasks/ThreadedInteraction/contexts/ChatTaskContext';

export enum StepWidth {
  Responsive = 'responsive',
  Full = 'full',
  Fit = 'fit',
}

type StepWidthWrapperProps = PropsWithChildren<{
  width?: StepWidth;
}>;
export const StepWidthWrapper: FC<StepWidthWrapperProps> = ({
  children,
  width = StepWidth.Responsive,
}) => {
  const stepWidth = useChatStoreExtract(state => state.stepWidth);
  const taskContext = useContext(ChatTaskContext);

  if (!children) return null;

  const isDynamicResponsive =
    stepWidth === GlobalStepWidth.Dynamic && width === StepWidth.Responsive;

  const isDynamicFit = stepWidth === GlobalStepWidth.Dynamic && width === StepWidth.Fit;

  return (
    <div
      className={cn([
        (width === StepWidth.Full || stepWidth === GlobalStepWidth.Full) && 'w-full',
        isDynamicResponsive &&
          (taskContext.enableUnifiedFeedback
            ? taskContext.contextSource !== 'ChatBulkAudit'
              ? 'md:w-[36rem] lg:w-[56rem] xl:w-[64rem]'
              : 'md:w-[32rem] lg:w-[48rem] xl:w-[56rem]'
            : 'md:w-[32rem] lg:w-[48rem]'),
        isDynamicFit &&
          (taskContext.enableUnifiedFeedback
            ? taskContext.contextSource !== 'ChatBulkAudit'
              ? 'w-fit md:min-w-[36rem] lg:min-w-[56rem] xl:min-w-[64rem] md:max-w-screen-lg lg:max-w-screen-xl xl:max-w-screen-2xl'
              : 'w-fit md:min-w-[32rem] lg:min-w-[48rem] xl:min-w-[56rem] md:max-w-screen-lg lg:max-w-screen-xl xl:max-w-screen-2xl'
            : 'w-fit md:min-w-[32rem] lg:min-w-[48rem] md:max-w-screen-lg lg:max-w-screen-xl'),
      ])}
    >
      {children}
    </div>
  );
};
